// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.detail-item-container-Li3QQ {
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  border-bottom: 1px solid var(--border-color);
  gap: 12px;
  padding: 16px 0px;
}

.detail-item-container-Li3QQ:last-child {
  border-bottom: none;
}

.detail-item-title-uWEXd {
  font-size: 15px;
  font-weight: 500;
}

.detail-item-text-bcMsu {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.8);
}

.detail-item-medium-xwsXP {
  font-weight: 500;
}

.detail-item-green-rPrMh {
  color: var(--money-color);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/detail-item/detail-item.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4CAA4C;EAC5C,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  display: flex;\n  justify-content: space-between;\n  flex-flow: row wrap;\n  border-bottom: 1px solid var(--border-color);\n  gap: 12px;\n  padding: 16px 0px;\n}\n\n.container:last-child {\n  border-bottom: none;\n}\n\n.title {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.text {\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.medium {\n  font-weight: 500;\n}\n\n.green {\n  color: var(--money-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `detail-item-container-Li3QQ`,
	"title": `detail-item-title-uWEXd`,
	"text": `detail-item-text-bcMsu`,
	"medium": `detail-item-medium-xwsXP`,
	"green": `detail-item-green-rPrMh`
};
export default ___CSS_LOADER_EXPORT___;
